<template>
  <div ref="tabbar" class="emd-tabbar" :class="classList">
    <ul class="emd-tabbar__list">
      <li class="emd-tabbar__item" v-for="(item, index) in routesWizard" :key="index" :class="{ '_disabled': !hasPermission(item, index) }">
        <a
          class="emd-tabbar__link"
          :id="`tabbarItem${index}`"
          @click="changeRoute(item, index)"
          :class="{ '_active': activeLink === item.component }">
          <span class="emd-text _type_label _size_small eu-ml_1">{{ `${index + 1}. ${$t(item.component)}` }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EmdTabbar',
  props: {
    color: {
      type: String,
      required: false,
      default: null,
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary', null].indexOf(value) !== -1
      }
    },
    bordered: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: null
    },
    justify: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    routesWizard () {
      return this.$store.getters.routesWizard.filter((item) => {
        if (item.tabbar.includes(this.selectedPaymentType)) return item
      })
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    paymentMethodsEnabled () {
      return this.$store.getters.paymentMethodsEnabled
    },
    activeLink () {
      return !this.hasSubscriptionEnabled && this.$route.name === 'OrderType' ? 'Items' : this.$route.name
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    address () {
      return this.$store.getters.address
    },
    checkout () {
      return this.$store.getters.checkout
    },
    classList () {
      var classList = []
      if (this.size) {
        classList.push(`_size_${this.size}`)
      }
      if (this.bordered) {
        classList.push('_bordered')
      }
      if (this.justify) {
        classList.push(`_justify_${this.justify}`)
      }
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      return classList
    }
  },
  mounted () {
    const $tabbar = this.$refs.tabbar
    let startX
    let scrollLeft
    let isDown = false
    $tabbar.addEventListener('mousewheel', function (e) {
      e.preventDefault()
      $tabbar.scrollLeft += e.deltaY
    }, false)
    $tabbar.addEventListener('mousedown', function (e) {
      isDown = true
      startX = e.pageX - $tabbar.offsetLeft
      scrollLeft = $tabbar.scrollLeft
    }, false)
    $tabbar.addEventListener('mousemove', function (e) {
      if (!isDown) return
      const x = e.pageX - $tabbar.offsetLeft
      const walk = (x - startX) * 2
      $tabbar.scrollLeft = scrollLeft - walk
    }, false)
    $tabbar.addEventListener('mouseup', function (e) {
      isDown = false
    }, false)
    $tabbar.addEventListener('touchstart', function (e) {
      isDown = true
      if (e.touches.length > 0) {
        startX = e.touches[0].pageX - $tabbar.offsetLeft
      } else {
        startX = e.pageX - $tabbar.offsetLeft
      }
      scrollLeft = $tabbar.scrollLeft
    }, false)
    $tabbar.addEventListener('touchmove', function (e) {
      if (!isDown) return
      var x
      if (e.touches.length > 0) {
        x = e.touches[0].pageX - $tabbar.offsetLeft
      } else {
        x = e.pageX - $tabbar.offsetLeft
      }
      const walk = (x - startX) * 2
      $tabbar.scrollLeft = scrollLeft - walk
    }, false)
    $tabbar.addEventListener('touchend', function (e) {
      isDown = false
    }, false)
  },
  methods: {
    hasPermission (item, index) {
      return !this.routesWizard.map((route, i) => { if (i < index) return route.permission }).includes(false) && item.permission
    },
    changeRoute (item, index) {
      const permission = this.hasPermission(item, index)
      if (permission && item.component !== this.activeLink) this.$router.push({ name: item.component })
      else {
        const lastRouteWithPermission = this.routesWizard[this.routesWizard.findIndex(route => !route.permission) - 1]
        if (lastRouteWithPermission.component === this.activeLink) {
          this.tabbarError.status = !permission
          this.showFeedbacks.status = !permission
          if (this.address.show_address) this.showFeedbacks.address = !permission
          if (this.checkout.accepted_payment_methods.includes('credit_card')) this.showFeedbacks.credit_card = !permission
          if (this.checkout.accepted_payment_methods.includes('boleto')) this.showFeedbacks.boleto = !permission
        } else this.$router.push({ name: lastRouteWithPermission.component })
      }
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "Items": "Pedido",
      "PaymentMethod": "Tipo de Cobrança",
      "Customer": "Dados do Cliente",
      "PaymentData": "Pagamento",
      "ReviewOrder": "Resumo",
      "SubscriptionDetails": "Dados da Recorrência"
    },
    "en-US": {
      "Items": "Order",
      "PaymentMethod": "Payment Method",
      "Customer": "Customer Information",
      "PaymentData": "Payment",
      "ReviewOrder": "Review",
      "SubscriptionDetails": "Subscription Details"
    }
  }
</i18n>
